// extracted by css-extract-rspack-plugin
export default {"Box":"Controls-module__Box__z7RL5","IconButton":"Controls-module__IconButton__pUyUj"};